import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import {UserForm} from "./UserForm";

function initUsersEdit() {

	const userForm = new UserForm({
		formElement: document.querySelector('.user-form'),
	});

	document.querySelector('.update-user-button').onclick = updateUser;

	/** Methods */

	function updateUser() {
		loading()

		userForm.submit()
			.then(handleAjaxSuccess)
			.finally(stopLoading);
	}
}

export {initUsersEdit}
